module.exports = __webpack_public_path__ + "img/精选好物.405a5bd7.png";